import i18next from 'i18next';

export const i18n = i18next.createInstance();

const savedLanguage = localStorage.getItem('language') || (navigator.language.startsWith('en') ? 'en' : 'pt');

i18n.init({
  lng: savedLanguage,
  fallbackLng: 'en',
  resources: {
    pt: {
      translation: {
        home: {
          configureTitle: "Configure o seu currículo",
          configureDescription: "Melhore suas entrevistas com um currículo otimizado para cada vaga.",
          startNow: "Começar Agora",
          buyCredits: "Comprar Créditos",
          badge: "USADO POR 1.000+ CANDIDATOS EM EMPRESAS TOP",
          heroLine1: "O Assistente de IA",
          heroLine2: "Nº1",
          heroLine3: "Invisível",
          heroLine4: "Para Entrevistas",
          subtitle: "A mais avançada tecnologia de assistência em tempo real. Captura áudio, transcreve instantaneamente e gera respostas inteligentes — 100% invisível no compartilhamento de tela.",
          getWindows: "Baixar para Windows",
          getMac: "Baixar para Mac",
          noCreditCard: "SEM CARTÃO DE CRÉDITO",
          signupBoxTitle: "Comece gratuitamente",
          signupBoxSubtitle: "Crie sua conta em segundos e experimente o SecretDev.",
          howItWorksLabel: "COMO FUNCIONA",
          howItWorksTitle: "Como somos 100% invisíveis",
          proofLabel: "PROVA",
          proofTitle: "A Prova Está na Comparação",
          proofSubtitle: "Compare lado a lado e descubra por que o SecretDev permanece invisível onde outros falham.",
          comparisonFeatures: "Funcionalidades",
          spotlightLabel: "FUNCIONALIDADES",
          spotlightTitle: "Tudo que você precisa para performar",
          spotlightSubtitle: "Mais de 15 funcionalidades de IA projetadas para entrevistas, reuniões, code reviews e muito mais.",
          contextsLabel: "CONTEXTOS DINÂMICOS",
          contextsTitle: "Múltiplos contextos, uma só ferramenta",
          contextsSubtitle: "Personalize a experiência escolhendo o tipo de situação: Entrevista de Desenvolvedor, Apresentação de Projeto, Defesa Acadêmica, Reunião Jurídica e muito mais.",
          ctaTitle: "Pronto para sua próxima entrevista?",
          ctaSubtitle: "Junte-se a milhares de candidatos que já conquistaram a vaga dos sonhos com o SecretDev.",
          manifesto: "Criado por desenvolvedores que vivem as mesmas dores que você. Sabemos o que é gerenciar múltiplos projetos, múltiplos trabalhos, múltiplas dailies — e ainda ter que performar em entrevistas técnicas, reuniões e code reviews. O SecretDev foi pensado para ser o braço direito do dev moderno.",
          footer: "SecretDev — Plataforma de Inteligência Artificial Multimodal: Ouvir | Ver | Interpretar | Agir",
          comparison: {
            supportsAudio: "Suporte a Áudio",
            invisibleScreenShare: "Invisível no Screen Share",
            invisibleTaskbar: "Invisível na Taskbar",
            invisibleTaskManager: "Invisível no Task Manager",
            clickThrough: "Click-Through (Raio-X)",
            aiResponses: "Respostas com IA",
            resumeContext: "Contexto do Currículo",
            multiContext: "Múltiplos Contextos",
            codeReview: "Revisão de Código com IA",
            aiResume: "Gerador de Currículo com IA",
            screenshotSolver: "Resolve Código por Print (escolha a linguagem)",
            xrayMode: "Modo Raio-X (edite por baixo do app)",
            meetingCompanion: "Companheiro de Reuniões",
          },
        },
        register: {
          title: "Criar Conta",
          emailPlaceholder: "Seu e-mail",
          passwordPlaceholder: "Sua senha",
          button: "Cadastrar",
          success: "Cadastro realizado! Faça login.",
          error: "Erro de cadastro",
          connectionError: "Erro de conexão com o servidor.",
        },
        buyPlans: {
          title: "Comprar Créditos SecretDev",
          credits: "créditos",
          credits_one: "crédito",
          credits_other: "créditos",
          buy: "Comprar",
          processing: "Processando...",
          subscribe: "Assinar",
          creditsPackTitle: "Pacote de Créditos",
          creditsDescription: "1 crédito = $1.00 USD. Escolha a quantidade:",
          monthlyPlanTitle: "Boost 600",
          month: "mês",
          fullAccess: "Acesso completo ao app",
          recommended: "RECOMENDADO",
          bestValue: "MELHOR CUSTO-BENEFÍCIO",
          flexibleBadge: "PERSONALIZÁVEL",
          perCredit: "por crédito",
          savePerCredit: "$0.29/crédito — economize 71%",
          supportEmail: "Dúvidas? Fale conosco",
          cancelled: "Pagamento cancelado. Você pode tentar novamente.",
        },
        payment: {
          checking: "Verificando pagamento...",
          successTitle: "Pagamento confirmado!",
          subscriptionActivated: "Sua assinatura foi ativada com sucesso!",
          creditsAdded: "créditos adicionados à sua conta!",
          creditsAddedGeneric: "Créditos adicionados à sua conta!",
          backHome: "Voltar ao início",
          pendingTitle: "Pagamento pendente",
          pendingMessage: "Seu pagamento ainda está sendo processado. Aguarde alguns instantes.",
          errorTitle: "Erro na verificação",
          errorMessage: "Não foi possível verificar seu pagamento. Entre em contato com o suporte.",
        },
        dashboard: {
          title: "Dashboard",
          loading: "Carregando...",
          stats: {
            interactions: "Interações",
            sessions: "Sessões",
            avgTime: "Tempo Médio",
            modelsUsed: "Modelos Usados",
          },
          modelUsageTitle: "Uso por Modelo",
          credits: "créditos",
          uses_one: "{{count}} uso",
          uses_other: "{{count}} usos",
          creditsLabel_one: "{{count}} crédito",
          creditsLabel_other: "{{count}} créditos",
          historyTitle: "Histórico de Entrevistas",
          perPage: "Por página",
          noSessions: "Nenhuma sessão de entrevista ainda.",
          selectAll: "Selecionar todos",
          questions: "perguntas",
          statusCompleted: "Concluída",
          statusActive: "Ativa",
          delete: "Deletar",
          deleting: "Deletando...",
          cancel: "Cancelar",
          deleteInterview: "Deletar entrevista",
          deleteInterviews: "Deletar entrevistas",
          deleteConfirmMessage: 'Tem certeza que deseja deletar "{{title}}"? Esta ação não pode ser desfeita.',
          bulkDeleteConfirmMessage: "Tem certeza que deseja deletar {{n}} entrevista(s)? Esta ação não pode ser desfeita.",
          previous: "Anterior",
          next: "Próxima",
          pageOf: "Página {{page}} de {{total}}",
          question: "Pergunta",
          noInteractions: "Nenhuma interação nesta sessão.",
          errorLoadingSession: "Erro ao carregar sessão.",
          toastDeleted: "Entrevista deletada",
          toastDeleteError: "Erro ao deletar entrevista",
          toastBulkDeleted: "{{n}} entrevista(s) deletada(s)",
          toastBulkDeleteError: "Erro ao deletar entrevistas",
        },
        nav: {
          home: "Home",
          createAccount: "Criar Conta",
          noAccount: "Não tem conta ainda?",
          login: "Login",
          logout: "Sair",
          admin: "Admin",
          buyPlans: "Comprar Créditos",
          user: "Usuário",
          status: "Status",
          activeClient: "Cliente ativo",
          pendingPayment: "Pagamento pendente",
          downloadApp: "Baixar App",
          credits: "créditos",
          profile: "Meu Perfil",
          pricing: "Preços",
          resume: "Currículo",
          dashboard: "Dashboard",
          practice: "Prática"
        },
        logoutModal: {
          title: "Deseja realmente sair?",
          confirm: "Sair",
          cancel: "Cancelar",
        },
        modals: {
          confirm: "Confirmar",
          cancel: "Cancelar",
          delete: "Excluir",
          deleteResumeMessage: "Tem certeza que deseja excluir este currículo?",
          deactivateUser: "Desativar o usuário",
          deleteUserMessage: "Excluir permanentemente o usuário",
          deleteUserWarning: "Esta ação não pode ser desfeita.",
        },
        admin: {
          title: "Área Administrativa",
          email: "Email",
          credits: "Créditos",
          paid: "Pago?",
          isAdmin: "Admin?",
          actions: "Ações",
          release: "Liberar",
          deactivate: "Desativar",
          deleteUser: "Excluir",
          userReleased: "Usuário liberado com sucesso!",
          userDeactivated: "Usuário desativado com sucesso!",
          userDeleted: "Usuário excluído com sucesso!",
          releaseError: "Erro ao liberar usuário.",
          deactivateError: "Erro ao desativar usuário.",
          deleteError: "Erro ao excluir usuário.",
          internalError: "Erro interno. Tente novamente mais tarde.",
          accessDenied: "Acesso negado. Faça login novamente.",
          loadError: "Erro ao carregar usuários. Tente novamente mais tarde.",
        },
        forgotPassword: {
          title: "Esqueceu sua senha?",
          placeholder: "Digite seu e-mail",
          button: "Enviar link de redefinição",
          sendError: "Erro ao enviar email",
        },
        resetPassword: {
          title: "Redefinir Senha",
          placeholder: "Digite a nova senha",
          button: "Redefinir senha",
          success: "Senha atualizada com sucesso!",
          error: "Erro ao redefinir a senha.",
          networkError: "Erro de rede ao redefinir senha.",
        },
        changePassword: {
          title: "Trocar Senha",
          currentPassword: "Senha atual",
          newPassword: "Nova senha",
          button: "Atualizar Senha",
          success: "Senha alterada com sucesso.",
          error: "Erro ao alterar senha.",
          connectionError: "Erro de conexão com o servidor.",
        },
        profile: {
          title: "Meu Perfil",
          accountInfo: "Informações da Conta",
          resumeSettings: "Configurações de Currículo",
          email: "Email",
          accountStatus: "Status da Conta",
          statusPaid: "Cliente Ativo",
          statusFree: "Conta Gratuita",
          credits: "Créditos Disponíveis",
          creditsCount: "{{count}} créditos",
          changePassword: "Alterar Senha",
          configureResume: "Configurar Currículo",
          generateWithAI: "Gerar com IA",
        },
        resumePreview: {
          tunedResume: "Currículo Tunado",
          suggestedSkills: "Skills Sugeridas",
          loading: "Carregando currículo tunado...",
        },
        practice: {
          title: "Modo Prática",
          subtitle: "Treine para entrevistas — IA faz perguntas e avalia suas respostas.",
          statusInitial: "Escolha o tipo de pergunta e clique Gerar",
          statusGenerating: "Gerando pergunta...",
          statusGenerated: "Pergunta gerada! Escreva sua resposta abaixo.",
          statusEvaluating: "Avaliando sua resposta...",
          statusEvalComplete: "Avaliação completa! Gere outra pergunta pra continuar.",
          errorPrefix: "Erro: ",
          typeTechnical: "Técnica",
          typeBehavioral: "Comportamental",
          typeMotivational: "Motivacional",
          typeBrainTeaser: "Brain Teaser",
          generating: "Gerando...",
          generateButton: "Gerar Pergunta",
          questionLabel: "Pergunta:",
          yourAnswerLabel: "Sua Resposta:",
          answerPlaceholder: "Escreva sua resposta aqui como se estivesse falando na entrevista...",
          evaluating: "Avaliando...",
          evaluateButton: "Avaliar Resposta",
          evaluationLabel: "Avaliação:",
        },
        curriculoOriginal: {
          experiences: "Experiências:",
          noExperience: "Nenhuma experiência cadastrada.",
        },
        curriculoTunado: {
          experiences: "Experiências:",
          noDescription: "Descrição não disponível",
          noCompany: "Empresa não especificada",
          noRole: "Cargo não especificado",
        },
        toasts: {
          loginSuccess: "Login realizado com sucesso!",
          loginError: "Erro no login",
          connectionError: "Erro de conexão com o servidor.",
          registerSuccess: "Cadastro realizado! Faça login.",
          registerError: "Erro de cadastro",
          resumeSaved: "Currículo salvo com sucesso!",
          resumeSaveError: "Erro ao salvar currículo.",
          resumeDeleted: "Currículo excluído com sucesso",
          resumeDeleteError: "Erro ao excluir currículo",
          resumeFetchError: "Erro ao buscar currículos alternativos",
          altResumeUpdated: "Currículo alternativo atualizado com sucesso!",
          altResumeUpdateError: "Erro ao atualizar currículo alternativo.",
          paymentError: "Erro ao iniciar pagamento.",
          checkoutError: "Erro de conexão.",
          creditsInsufficient: "Créditos insuficientes.",
        },
        features: {
          status: {
            pending: "Pendente",
            implemented: "Implementado",
            onDevelopment: "Em Desenvolvimento "
          },
          avatarAssistant: {
            title: "Avatar Inteligente",
            description: "Interaja com um avatar animado que responde com voz sincronizada e expressões realistas, trazendo mais vida à sua IA pessoal."
          },
          careerCoach: {
            title: "Coach de Carreira",
            description: "Gere cartas de apresentação, receba feedback do seu currículo e treine entrevistas com base em vagas reais."
          },
          codingAssistant: {
            title: "Assistente para Coding Sessions",
            description: "Durante sessões de programação, o app detecta problemas ou dúvidas e gera blocos de código ou correções baseadas em IA."
          },
          curriculoIA: {
            title: "Currículo com IA",
            description: "Edite seu currículo com inteligência artificial e conquiste a atenção dos recrutadores com descrições impactantes e alinhadas à vaga."
          },
          educationTrainer: {
            title: "Treinador Educacional",
            description: "Treine para provas orais, bancas e apresentações acadêmicas com perguntas guiadas, feedback e simulações reais."
          },
          executiveCoach: {
            title: "Coach de Reuniões Executivas",
            description: "Receba apoio estratégico para responder objeções ou liderar reuniões. Troque o tom da IA (agressivo, neutro, empático) dinamicamente."
          },
          inclusionTool: {
            title: "Ferramenta de Inclusão",
            description: "Transcreva e interprete reuniões em tempo real para pessoas com deficiência auditiva ou cognitiva, com explicações simplificadas."
          },
          insightsDashboard: {
            title: "Painel de Insights",
            description: "Visualize o seu desempenho ao longo do tempo com gráficos, notas de feedback e histórico de evolução em simulações."
          },
          legalSupport: {
            title: "Suporte para Audiências Jurídicas",
            description: "Escute perguntas jurídicas e receba respostas baseadas em jurisprudência. Capture documentos e interprete informações rapidamente."
          },
          oralExamHelp: {
            title: "Auxílio em Provas Orais",
            description: "Escute perguntas da banca e receba dicas de como argumentar melhor. Capture trechos de defesa e obtenha sugestões em tempo real."
          },
          presentationAssistant: {
            title: "Assistente para Apresentações",
            description: "Escute perguntas da plateia e receba sugestões de resposta como um palestrante confiante. Capture slides e gere resumos didáticos."
          },
          smartCapture: {
            title: "Captura Inteligente com Contexto",
            description: "Capture imagens de códigos e selecione linguagens específicas para afinar a resposta da IA, tornando a resolução ainda mais precisa e poderosa."
          },
          speakerCoach: {
            title: "Treinador de Palestras",
            description: "Simule apresentações com tempo cronometrado, receba sugestões de fala, entonação e comportamento de palco."
          },
          techSupport: {
            title: "Suporte Técnico (Help Desk)",
            description: "Escute problemas relatados por clientes e gere soluções automáticas. Capture telas de erro e receba diagnósticos assistidos por IA."
          },
          translator: {
            title: "Intérprete com Voz",
            description: "Fale em um idioma e receba a resposta traduzida com voz em outro idioma. Perfeito para reuniões multilíngues e comunicação global."
          },
          xrayMode: {
            title: "Modo Raio-X Exclusivo",
            description: "Ative o modo Raio-X e torne a janela do app flutuante e translúcida, permitindo escrever ou interagir na aplicação abaixo."
          },
          stealthMode: {
            title: "100% Invisível no Compartilhamento de Tela",
            description: "O SecretDev não se esconde — ele simplesmente não existe para o compartilhamento de tela. Através de uma integração exclusiva com o sistema operacional, a janela do SecretDev é fisicamente excluída de qualquer captura de vídeo: Zoom, Google Meet, Teams, Discord, OBS — nenhum software consegue enxergá-la. Não é sobreposição, não é transparência, não é truque. A janela é invisível no nível do sistema."
          },
          meetingCompanion: {
            title: "Companheiro de Reuniões",
            description: "Nunca mais perca um detalhe. O SecretDev acompanha suas reuniões em tempo real, transcreve tudo automaticamente, permite anotações e capturas de tela de código ou documentos durante a call, e ao final dispara um e-mail completo com resumo, transcrição, screenshots e notas para você e todos os participantes. Ideal para devs que gerenciam múltiplos projetos e precisam manter o contexto de cada um sem esforço."
          },
          codeReviewer: {
            title: "Assistente de Revisão de Código",
            description: "O SecretDev lê seu projeto inteiro — ou vários ao mesmo tempo, como micro frontends e microsserviços — e te dá respostas imediatas sobre qualquer pergunta técnica. Quando o recrutador pedir para explicar suas decisões de arquitetura, a IA gera diagramas instantaneamente para elucidar seu raciocínio e te orienta com argumentos sólidos sobre patterns, trade-offs e boas práticas. Aqueles pequenos detalhes que eliminam candidatos no processo técnico. Fique à frente dos seus concorrentes. Use SecretDev."
          },
          screenshotSolver: {
            title: "Resolva Qualquer Exercício com um Print",
            description: "Tire um print do exercício do recrutador e receba a solução completa em segundos. Algoritmos, bugs escondidos, refatoração, complexidade — a IA analisa o snippet da tela, identifica o problema e entrega o código resolvido com explicação passo a passo. Funciona com qualquer linguagem e qualquer tipo de desafio técnico que aparecer na sua entrevista."
          }
        },
        "resumePdf": {
          "downloadPdf": "Baixar PDF",
          "contact": "Contato",
          "skills": "Habilidades",
          "languages": "Idiomas",
          "references": "Referências",
          "experiences": "Experiência",
          "education": "Educação",
          "phone": "Telefone",
          "email": "Email",
          "address": "Endereço",
          "website": "Website",
          "github": "GitHub",
          "linkedin": "LinkedIn"
        },
        configureResume: {
          "visualizePdf": "Visualizar PDF",
          "resumeConfig": "Configure seu Currículo",
          "experiences": "Experiências",
          "sendResume": "Enviar Currículo",
          "aiGeneratorResume": "Gerar Currículo com IA",
          "savedAlternativeResumes": "Currículos Alternativos Salvos",
          "personalInfo": "Informações Pessoais",
          "name": "Nome",
          "email": "Email",
          "phone": "Telefone",
          "address": "Endereço",
          "website": "Website",
          "linkedin": "LinkedIn",
          "github": "GitHub",
          "editing": "Editando currículo:",
          "save": "Salvar",
          "cancel": "Cancelar",
          "edit": "Editar",
          "delete": "Excluir",
          "noExperience": "Nenhuma experiência cadastrada.",
          "previous": "Anterior",
          "next": "Próximo",
          "desiredRole": "Cargo Desejado",
          "summary": "Resumo Profissional",
          "skills": "Habilidades",
          "languages": "Idiomas",
          "references": "Referências",
          "hintCommaSeparated": "Separe item usando vírgula.",
          "hintReferencesFormat": "Um por linha, no formato: Nome - Contato",
          "placeholder": {
            "name": "Ex: Seu nome",
            "phone": "+55 11 99999-9999",
            "email": "seuemail@dominio.com",
            "address": "Rua Exemplo, 123 - Cidade - UF",
            "website": "https://seudominio.com",
            "linkedin": "https://linkedin.com/in/seunome",
            "github": "https://github.com/seunome",
            "desiredRole": "Ex: Desenvolvedor Full Stack",
            "summary": "Ex: Profissional com 5 anos de experiência em desenvolvimento web...",
            "skills": "Ex: JavaScript, React, Node.js",
            "languages": "Ex: Português, Inglês",
            "references": "Ex: João Silva - joao@email.com"
          },
          "education": "Educação",
          "university": "Universidade",
          "course": "Curso",
          "startDate": "Data de Início",
          "endDate": "Data de Término",
          "labelOriginal": "Original",
          "labelAiGenerated": "Gerado com IA",
          experienceForm: {
            title: "Experiência Profissional",
            company: "Empresa",
            companyPlaceholder: "Ex: Bosch",
            role: "Cargo",
            rolePlaceholder: "Ex: Engenheiro de Software",
            description: "Descrição da experiência",
            descriptionPlaceholder: "Ex: Responsável pelo desenvolvimento do app mobile com React Native...",
            startDate: "Data de Início",
            endDate: "Data de Término",
            isCurrentJob: "Trabalho atual",
            present: "Presente",
            add: "Adicionar nova empresa",
            remove: "Remover"
          }
        },
        download: {
          title: "Download do SecretDev",
          thankYou: "Obrigado por apoiar o projeto!",
          button: "Baixar agora",
          accessDenied: "Acesso negado.",
          started: "Download iniciado!",
          paymentPending: "Pagamento pendente. Adquira um plano para baixar.",
          error: "Erro ao iniciar download.",
          connectionError: "Erro de conexão.",
        },
        "generateResume": {
          "title": "Gerar Currículo com IA",
          "textareaPlaceholder": "Cole aqui a descrição da vaga que você está aplicando",
          "back": "Voltar",
          "sendToAI": "Enviar para IA",
          "loading": "Gerando...",
          "comparisonTitle": "Comparativo do Currículo",
          "oldResume": "Currículo Antigo",
          "saveAsNew": "Salvar como novo currículo",
          "errorMissingFields": "Preencha a descrição da vaga e tenha ao menos uma experiência.",
          "errorGenerate": "Erro ao gerar currículo com IA.",
          "errorConnection": "Erro de conexão ao gerar currículo com IA.",
          "errorSave": "Erro ao salvar currículo.",
          "successSave": "Currículo salvo com sucesso!",
          "namePrompt": "Dê um nome para este currículo:",
          "creditConfirmMessage": "Esta operação consumirá 1 crédito. Deseja continuar?",
          "creditConfirm": "Confirmar",
          "creditCancel": "Cancelar",
          "operationCancelled": "Operação cancelada.",
          "outputLanguage": "Idioma do currículo gerado"
        },
        "validation": {
          "emailRequired": "E-mail é obrigatório",
          "emailInvalid": "E-mail inválido",
          "emailMissingAt": "Inclua um \"@\" no endereço de e-mail",
          "passwordRequired": "Senha é obrigatória",
          "passwordMinLength": "A senha deve ter no mínimo {{count}} caracteres",
          "passwordConfirmRequired": "Confirmação de senha é obrigatória",
          "passwordsMismatch": "As senhas não coincidem",
          "fieldRequired": "{{field}} é obrigatório",
          "urlRequired": "URL é obrigatória",
          "urlInvalid": "URL inválida",
          "phoneRequired": "Telefone é obrigatório",
          "phoneInvalid": "Telefone inválido",
          "minLength": "{{field}} deve ter no mínimo {{count}} caracteres",
          "maxLength": "{{field}} deve ter no máximo {{count}} caracteres",
          "dateFuture": "A data não pode ser no futuro"
        },
        tutorial: {
          title: "Tutorial",
          usesHeading: "Recomendado para",
          doHeading: "Faça",
          dontHeading: "Evite",
          tabs: {
            interface: "Interface",
            modos: "Modos",
            atalhos: "Atalhos",
            recomendacoes: "Recomendações",
          },
          modes: {
            entrevista: {
              label: "Entrevista",
              intro: "Captura a pergunta por <strong class='text-gray-200'>voz</strong> ou <strong class='text-gray-200'>print</strong> e devolve uma resposta pronta e estruturada — no formato certo para cada situação (STAR para comportamental, REACTO para live coding, ADR para arquitetura). Invisível no compartilhamento de tela.",
              steps: {
                s1: {
                  title: "Configure a vaga (opcional)",
                  body: "No header, use o dropdown <strong class='text-gray-200'>\"Vaga: …\"</strong> para criar ou ativar uma vaga. Dica: use <strong class='text-gray-200'>Importar via texto (✨)</strong> — cole o anúncio do LinkedIn e a IA extrai empresa, cargo e senioridade. As respostas se adaptam ao estilo da empresa e da etapa.",
                },
                s2: {
                  title: "Capture a pergunta",
                  body: "Se quiser, fixe a <strong class='text-gray-200'>linguagem</strong> no menu (☰) — o padrão é detectar sozinho (\"Auto-detect ▾\"). Grave o áudio com <kbd class='kbd'>Ctrl/Cmd+Shift+Z</kbd> (iniciar) e <kbd class='kbd'>Ctrl/Cmd+Shift+X</kbd> (parar), ou capture um print com <kbd class='kbd'>Ctrl/Cmd+Shift+S</kbd> — também dá para colar a imagem do clipboard com <kbd class='kbd'>Ctrl/Cmd+Shift+V</kbd>.",
                },
                s3: {
                  title: "Receba a resposta",
                  body: "A IA responde em streaming com a abordagem, o Big O e o código pronto. Precisa reenviar os anexos? Use <kbd class='kbd'>Ctrl/Cmd+Shift+R</kbd>.",
                },
                s4: {
                  title: "Use com discrição",
                  body: "Ligue o <strong class='text-gray-200'>modo Cola</strong> (<kbd class='kbd'>Ctrl/Cmd+Shift+G</kbd>) para ver só a resposta, ou o <strong class='text-gray-200'>mini-mode</strong> (<kbd class='kbd'>Ctrl/Cmd+Shift+F</kbd>) para uma janela compacta. Para \"digitar\" o código direto no editor, use a <strong class='text-gray-200'>auto-digitação</strong> (<kbd class='kbd'>Ctrl/Cmd+Shift+T</kbd>), que remove os comentários — cancela com <kbd class='kbd'>Esc</kbd>.",
                },
              },
              uses: [
                "Testes de código online (LeetCode, HackerRank, CoderPad, Codility)",
                "Entrevista técnica ao vivo: teoria, system design, live coding",
                "Entrevistas comportamentais (respostas em STAR / STAR-L)",
                "Processos de Amazon, Google, Meta — ajusta o estilo automaticamente",
              ],
            },
            reuniao: {
              label: "Reunião",
              intro: "O app <strong class='text-gray-200'>transcreve a reunião inteira</strong> e, ao final, gera um resumo com IA e <strong class='text-gray-200'>envia por e-mail</strong> aos participantes que você cadastrar — com resumo, notas e comentários.",
              steps: {
                s1: {
                  title: "Adicione os participantes",
                  body: "Abra a seção <strong class='text-gray-200'>Participantes</strong> e adicione <strong class='text-gray-200'>nome + e-mail</strong> de quem deve receber o resumo — incluindo o seu, se você também quiser recebê-lo.",
                },
                s2: {
                  title: "Grave a reunião",
                  body: "Clique em <strong class='text-gray-200'>Iniciar</strong>. O app captura seu microfone <strong class='text-gray-200'>e o áudio do sistema</strong> e mostra a transcrição em tempo real. Durante a call você pode pausar/retomar e adicionar notas e comentários em momentos-chave.",
                },
                s3: {
                  title: "Revise a transcrição",
                  body: "Clique em <strong class='text-gray-200'>Finalizar</strong>. A transcrição fica <strong class='text-gray-200'>editável</strong> — corrija nomes e termos antes de enviar. Ela é salva localmente como rascunho, então você não perde nada se algo falhar.",
                },
                s4: {
                  title: "Envie o resumo",
                  body: "Clique em <strong class='text-gray-200'>Enviar</strong>. A IA gera o resumo e dispara um e-mail com resumo, transcrição, notas e comentários para todos os participantes.",
                },
              },
              mailNote: "<strong class='text-gray-200'>A entrega é por e-mail.</strong> Não há botão de \"baixar\" dentro do app — para ter sua cópia, basta <strong class='text-gray-200'>se adicionar como participante</strong>.",
              uses: [
                "Reuniões de alinhamento e daily/planning que precisam de ata",
                "Calls com cliente onde você quer registrar o combinado",
                "Aulas e webinars para revisar depois",
                "Quando você quer prestar atenção sem anotar tudo à mão",
              ],
            },
            codigo: {
              label: "Análise de Código",
              intro: "Aponte para um <strong class='text-gray-200'>repositório no seu computador</strong> e pergunte por voz. A IA lê o código de verdade (Claude Code), explica, e pode propor e aplicar correções com <strong class='text-gray-200'>checkpoints de git</strong> para desfazer.",
              steps: {
                s1: {
                  title: "Selecione o repositório",
                  body: "Abra o modo <strong class='text-gray-200'>Análise de Código</strong> e escolha a pasta do projeto no seu computador.",
                },
                s2: {
                  title: "Pergunte por voz",
                  body: "Grave sua pergunta com <kbd class='kbd'>Ctrl/Cmd+Shift+Z</kbd> / <kbd class='kbd'>Ctrl/Cmd+Shift+X</kbd>. A IA responde com base no código real do repositório.",
                },
                s3: {
                  title: "Ou descreva um bug por escrito",
                  body: "No painel <strong class='text-gray-200'>Code Assistant</strong>, digite o problema (ex: \"o rate limiter não bloqueia a 5ª request\") e clique em <strong class='text-gray-200'>Propor correção</strong> — sem precisar gravar áudio.",
                },
                s4: {
                  title: "Aplique correções com segurança",
                  body: "Quando a IA propõe uma mudança, cada aplicação cria um <strong class='text-gray-200'>checkpoint de git</strong> — se não gostar, é só desfazer.",
                },
              },
              uses: [
                "Entender um projeto ou base de código desconhecida",
                "Pair programming: propor e aplicar mudanças com segurança",
                "Debug e refatoração com contexto do repositório inteiro",
                "Preparar-se para um take-home clonado na sua máquina",
              ],
            },
            pratica: {
              label: "Prática",
              intro: "A IA faz as perguntas, você responde por voz e recebe <strong class='text-gray-200'>feedback</strong> — escolha entre técnica, comportamental, motivacional ou brain teaser.",
              steps: {
                s1: {
                  title: "Escolha o tipo de pergunta",
                  body: "Abra o <strong class='text-gray-200'>Modo Prática</strong> e selecione entre técnica, comportamental, motivacional ou brain teaser. As perguntas usam seu currículo como base.",
                },
                s2: {
                  title: "Responda por voz",
                  body: "A IA faz a pergunta; você responde falando. Ao final de cada resposta, recebe uma crítica com pontos fortes e o que melhorar.",
                },
              },
              uses: [
                "Ensaiar antes de uma entrevista de verdade",
                "Treinar respostas comportamentais e receber crítica",
                "Praticar perguntas técnicas com base no seu currículo",
                "Ganhar fluência falando em outro idioma",
              ],
            },
          },
          interface: {
            intro: "No modo Entrevista, tudo fica na <strong class='text-gray-200'>barra de ferramentas do topo</strong>. O que faz cada botão, da esquerda para a direita:",
            caption: "Modo Entrevista: barra de ferramentas no topo, Transcrição e Resposta do Oráculo logo abaixo.",
            alt: "Interface do modo Entrevista do SecretDev com a barra de ferramentas do topo",
            toolbarHeading: "Barra de ferramentas",
            toolbar: {
              back: "Voltar ao menu de modos",
              xray: "Raio-X (clicar através da janela)",
              menu: "Menu (vaga, estilo, opções)",
              info: "Info / ajuda",
              color: "Mudar a cor das respostas",
              font: "Aumentar / diminuir a fonte",
              clear: "Limpar o histórico",
              history: "Mostrar / ocultar o histórico",
              replay: "Replay de sessões salvas",
              mock: "Mock interview",
              credits: "Saldo de créditos restante",
            },
            menuHeading: "Dentro do menu (☰)",
            menu: {
              monitor: "Escolher qual tela capturar",
              lang: "Linguagem do código (ou fixe uma)",
            },
          },
          shortcuts: {
            recHeading: "Gravação & respostas",
            recording: {
              start: "Iniciar gravação",
              stop: "Parar gravação",
              screenshot: "Capturar screenshot",
              paste: "Colar imagem + resolver",
              solve: "Resolver anexos",
              autotype: "Auto-digitar resposta",
            },
            winHeading: "Janela & discrição",
            window: {
              cola: "Modo Cola (só resposta)",
              mini: "Mini-mode compacto",
              xray: "Raio-X (clicar através)",
              notes: "Painel de notas",
              snippet: "Snippet Bank",
              all: "Ver todos os atalhos",
            },
            footer: "Dentro do app, pressione <kbd class='kbd'>Ctrl/Cmd+?</kbd> a qualquer momento para ver a lista completa.",
          },
          recommendations: {
            intro: "A janela é invisível no compartilhamento de tela, mas <strong class='text-gray-200'>invisível não é indetectável</strong>. Siga estas recomendações para não se expor por outros caminhos.",
            tip: "<strong class='text-white'>Capture o enunciado por print — não copie o texto da página.</strong> O print (<kbd class='kbd'>Ctrl/Cmd+Shift+S</kbd>) não gera evento no site. Já o <strong class='text-gray-200'>Ctrl+C na página do teste</strong> dispara um evento <code class='text-brand-400'>copy</code> que a plataforma consegue observar.",
            do: [
              "Capture o enunciado por <strong class='text-gray-200'>print</strong>.",
              "<strong class='text-gray-200'>Teste a invisibilidade antes</strong>: grave sua tela e confirme que a janela some.",
              "Se pedirem compartilhar tela, compartilhe <strong class='text-gray-200'>só a aba do teste</strong>.",
              "Use os <strong class='text-gray-200'>atalhos globais</strong> — não roubam o foco da aba.",
              "<strong class='text-gray-200'>Digite você mesmo</strong> olhando a resposta.",
            ],
            dont: [
              "<strong class='text-gray-200'>Copiar o texto</strong> do enunciado na página (evento <code class='text-red-400'>copy</code>).",
              "<strong class='text-gray-200'>Auto-digitar</strong> em prova monitorada — digitação em bloco chama atenção.",
              "<strong class='text-gray-200'>Sair da aba</strong> do teste — troca de aba é muito monitorada.",
              "Confiar na invisibilidade <strong class='text-gray-200'>sem ter testado</strong>.",
              "Olhar para um <strong class='text-gray-200'>segundo monitor / celular</strong> (aparece na webcam).",
            ],
            cards: {
              share: {
                title: "Compartilhar tela — protegido",
                body: "É onde o app te cobre: a janela sai invisível na captura, mesmo em tela cheia. <strong class='text-gray-200'>Faça um teste antes</strong> para confirmar no seu SO.",
              },
              webcam: {
                title: "Webcam — cuidado",
                body: "A câmera vê <strong class='text-gray-200'>você</strong>, não a tela. Basta cuidar do seu comportamento e da direção do olhar.",
              },
              proctor: {
                title: "Proctoring instalado — atenção",
                body: "Se o processo exigir <strong class='text-gray-200'>instalar um software de monitoramento</strong>, a invisibilidade de tela não cobre tudo — ali a detecção passa a ser por processo no seu computador.",
              },
            },
          },
        }
      }
    },
    en: {
      translation: {
        nav: {
          home: "Home",
          createAccount: "Create Account",
          noAccount: "Don't have an account yet?",
          login: "Login",
          logout: "Logout",
          admin: "Admin",
          buyPlans: "Buy Credits",
          user: "User",
          status: "Status",
          activeClient: "Active Client",
          pendingPayment: "Pending Payment",
          downloadApp: "Download App",
          credits: "credits",
          profile: "My Profile",
          pricing: "Pricing",
          resume: "Resume",
          dashboard: "Dashboard",
          practice: "Practice"
        },
        register: {
          title: "Create Account",
          emailPlaceholder: "Your email",
          passwordPlaceholder: "Your password",
          button: "Register",
          success: "Registration successful! Please log in.",
          error: "Registration error",
          connectionError: "Connection error with the server.",
        },
        login: {
          title: "Login",
          emailPlaceholder: "Your email",
          passwordPlaceholder: "Your password",
          button: "Sign In",
          success: "Login successful!",
          error: "Login error",
          connectionError: "Connection error with the server.",
        },
        buyPlans: {
          title: "Buy SecretDev Credits",
          credits: "credits",
          credits_one: "credit",
          credits_other: "credits",
          buy: "Buy",
          processing: "Processing...",
          subscribe: "Subscribe",
          creditsPackTitle: "Credits Pack",
          creditsDescription: "1 credit = $1.00 USD. Choose the amount:",
          monthlyPlanTitle: "Boost 600",
          month: "month",
          fullAccess: "Full app access",
          recommended: "RECOMMENDED",
          bestValue: "BEST VALUE",
          flexibleBadge: "CUSTOMIZABLE",
          perCredit: "per credit",
          savePerCredit: "$0.29/credit — save 71%",
          supportEmail: "Questions? Contact us",
          cancelled: "Payment cancelled. You can try again.",
        },
        payment: {
          checking: "Checking payment...",
          successTitle: "Payment confirmed!",
          subscriptionActivated: "Your subscription has been activated!",
          creditsAdded: "credits added to your account!",
          creditsAddedGeneric: "Credits added to your account!",
          backHome: "Back to Home",
          pendingTitle: "Payment pending",
          pendingMessage: "Your payment is still being processed. Please wait a moment.",
          errorTitle: "Verification error",
          errorMessage: "Unable to verify your payment. Please contact support.",
        },
        dashboard: {
          title: "Dashboard",
          loading: "Loading...",
          stats: {
            interactions: "Interactions",
            sessions: "Sessions",
            avgTime: "Avg. Time",
            modelsUsed: "Models Used",
          },
          modelUsageTitle: "Usage by Model",
          credits: "credits",
          uses_one: "{{count}} use",
          uses_other: "{{count}} uses",
          creditsLabel_one: "{{count}} credit",
          creditsLabel_other: "{{count}} credits",
          historyTitle: "Interview History",
          perPage: "Per page",
          noSessions: "No interview sessions yet.",
          selectAll: "Select all",
          questions: "questions",
          statusCompleted: "Completed",
          statusActive: "Active",
          delete: "Delete",
          deleting: "Deleting...",
          cancel: "Cancel",
          deleteInterview: "Delete interview",
          deleteInterviews: "Delete interviews",
          deleteConfirmMessage: 'Are you sure you want to delete "{{title}}"? This action cannot be undone.',
          bulkDeleteConfirmMessage: "Are you sure you want to delete {{n}} interview(s)? This action cannot be undone.",
          previous: "Previous",
          next: "Next",
          pageOf: "Page {{page}} of {{total}}",
          question: "Question",
          noInteractions: "No interactions in this session.",
          errorLoadingSession: "Error loading session.",
          toastDeleted: "Interview deleted",
          toastDeleteError: "Error deleting interview",
          toastBulkDeleted: "{{n}} interview(s) deleted",
          toastBulkDeleteError: "Error deleting interviews",
        },
        logoutModal: {
          title: "Do you really want to logout?",
          confirm: "Logout",
          cancel: "Cancel",
        },
        modals: {
          confirm: "Confirm",
          cancel: "Cancel",
          delete: "Delete",
          deleteResumeMessage: "Are you sure you want to delete this résumé?",
          deactivateUser: "Deactivate user",
          deleteUserMessage: "Permanently delete user",
          deleteUserWarning: "This action cannot be undone.",
        },
        admin: {
          title: "Admin Panel",
          email: "Email",
          credits: "Credits",
          paid: "Paid?",
          isAdmin: "Admin?",
          actions: "Actions",
          release: "Release",
          deactivate: "Deactivate",
          deleteUser: "Delete",
          userReleased: "User released successfully!",
          userDeactivated: "User deactivated successfully!",
          userDeleted: "User deleted successfully!",
          releaseError: "Error releasing user.",
          deactivateError: "Error deactivating user.",
          deleteError: "Error deleting user.",
          internalError: "Internal error. Please try again later.",
          accessDenied: "Access denied. Please log in again.",
          loadError: "Error loading users. Please try again later.",
        },
        forgotPassword: {
          title: "Forgot your password?",
          placeholder: "Enter your email",
          button: "Send reset link",
          sendError: "Error sending email",
        },
        resetPassword: {
          title: "Reset Password",
          placeholder: "Enter new password",
          button: "Reset password",
          success: "Password updated successfully!",
          error: "Error resetting password.",
          networkError: "Network error while resetting password.",
        },
        changePassword: {
          title: "Change Password",
          currentPassword: "Current password",
          newPassword: "New password",
          button: "Update Password",
          success: "Password changed successfully.",
          error: "Error changing password.",
          connectionError: "Connection error with the server.",
        },
        profile: {
          title: "My Profile",
          accountInfo: "Account Information",
          resumeSettings: "Resume Settings",
          email: "Email",
          accountStatus: "Account Status",
          statusPaid: "Active Client",
          statusFree: "Free Account",
          credits: "Available Credits",
          creditsCount: "{{count}} credits",
          changePassword: "Change Password",
          configureResume: "Configure Resume",
          generateWithAI: "Generate with AI",
        },
        resumePreview: {
          tunedResume: "Tuned Résumé",
          suggestedSkills: "Suggested Skills",
          loading: "Loading tuned résumé...",
        },
        practice: {
          title: "Practice Mode",
          subtitle: "Train for interviews — AI asks questions and evaluates your answers.",
          statusInitial: "Choose the question type and click Generate",
          statusGenerating: "Generating question...",
          statusGenerated: "Question generated! Write your answer below.",
          statusEvaluating: "Evaluating your answer...",
          statusEvalComplete: "Evaluation complete! Generate another question to continue.",
          errorPrefix: "Error: ",
          typeTechnical: "Technical",
          typeBehavioral: "Behavioral",
          typeMotivational: "Motivational",
          typeBrainTeaser: "Brain Teaser",
          generating: "Generating...",
          generateButton: "Generate Question",
          questionLabel: "Question:",
          yourAnswerLabel: "Your Answer:",
          answerPlaceholder: "Write your answer here as if you were speaking in the interview...",
          evaluating: "Evaluating...",
          evaluateButton: "Evaluate Answer",
          evaluationLabel: "Evaluation:",
        },
        curriculoOriginal: {
          experiences: "Experiences:",
          noExperience: "No experience registered.",
        },
        curriculoTunado: {
          experiences: "Experiences:",
          noDescription: "Description not available",
          noCompany: "Company not specified",
          noRole: "Role not specified",
        },
        toasts: {
          loginSuccess: "Login successful!",
          loginError: "Login error",
          connectionError: "Connection error with the server.",
          registerSuccess: "Registration successful! Please log in.",
          registerError: "Registration error",
          resumeSaved: "Résumé saved successfully!",
          resumeSaveError: "Error saving résumé.",
          resumeDeleted: "Résumé deleted successfully",
          resumeDeleteError: "Error deleting résumé",
          resumeFetchError: "Error fetching alternative résumés",
          altResumeUpdated: "Alternative résumé updated successfully!",
          altResumeUpdateError: "Error updating alternative résumé.",
          paymentError: "Error starting payment.",
          checkoutError: "Connection error.",
          creditsInsufficient: "Insufficient credits.",
        },
        home: {
          configureTitle: "Set up your résumé",
          configureDescription: "Improve your interviews with a résumé optimized for each job.",
          startNow: "Start Now",
          buyCredits: "Buy Credits",
          badge: "USED BY 1,000+ CANDIDATES AT TOP COMPANIES",
          heroLine1: "The No.",
          heroLine2: "1",
          heroLine3: "Invisible",
          heroLine4: "AI For Interviews",
          subtitle: "The most advanced real-time assistance technology. Captures audio, transcribes instantly, and generates intelligent answers — 100% invisible on screen share.",
          getWindows: "Get for Windows",
          getMac: "Get for Mac",
          noCreditCard: "NO CREDIT CARD NEEDED",
          signupBoxTitle: "Start for free",
          signupBoxSubtitle: "Create your account in seconds and try SecretDev.",
          howItWorksLabel: "HOW IT WORKS",
          howItWorksTitle: "How we're 100% invisible",
          proofLabel: "PROOF",
          proofTitle: "The Proof Is in the Comparison",
          proofSubtitle: "Compare side-by-side and find out why SecretDev stays invisible where others fail.",
          comparisonFeatures: "Features",
          spotlightLabel: "FEATURES",
          spotlightTitle: "Everything you need to perform",
          spotlightSubtitle: "15+ AI features designed for interviews, meetings, code reviews, and more.",
          contextsLabel: "DYNAMIC CONTEXTS",
          contextsTitle: "Multiple contexts, one tool",
          contextsSubtitle: "Customize the experience by choosing the situation type: Developer Interview, Project Presentation, Academic Defense, Legal Meeting, and much more.",
          ctaTitle: "Ready for your next interview?",
          ctaSubtitle: "Join thousands of candidates who already landed their dream job with SecretDev.",
          manifesto: "Built by developers who live the same struggles as you. We know what it's like to manage multiple projects, multiple workloads, multiple dailies — and still have to perform in technical interviews, meetings, and code reviews. SecretDev was designed to be the modern dev's right hand.",
          footer: "SecretDev — Multimodal Artificial Intelligence Platform: Listen | See | Interpret | Act",
          comparison: {
            supportsAudio: "Supports Audio",
            invisibleScreenShare: "Invisible to Screen Share",
            invisibleTaskbar: "Invisible to Taskbar",
            invisibleTaskManager: "Invisible to Task Manager",
            clickThrough: "Click-Through (X-Ray)",
            aiResponses: "AI-Powered Responses",
            resumeContext: "Résumé Context",
            multiContext: "Multiple Contexts",
            codeReview: "AI Code Review",
            aiResume: "AI Resume Generator",
            screenshotSolver: "Solve Code by Screenshot (choose language)",
            xrayMode: "X-Ray Mode (edit beneath the app)",
            meetingCompanion: "Meeting Companion",
          },
        },
        features: {
          status: {
            pending: "Pending",
            implemented: "Implemented",
            onDevelopment: "On Development"
          },
          avatarAssistant: {
            title: "Smart Avatar",
            description: "Interact with an animated avatar that responds with synchronized voice and realistic expressions, bringing your personal AI to life."
          },
          careerCoach: {
            title: "Career Coach",
            description: "Generate cover letters, get feedback on your résumé, and practice interviews based on real job postings."
          },
          codingAssistant: {
            title: "Coding Session Assistant",
            description: "During coding sessions, the app detects issues or doubts and generates code snippets or AI-based corrections."
          },
          curriculoIA: {
            title: "AI-Powered Resume",
            description: "Edit your résumé with artificial intelligence and capture recruiters' attention with impactful and targeted descriptions."
          },
          educationTrainer: {
            title: "Educational Trainer",
            description: "Train for oral exams, academic defenses, and presentations with guided questions, feedback, and realistic simulations."
          },
          executiveCoach: {
            title: "Executive Meeting Coach",
            description: "Receive strategic support to respond to objections or lead meetings. Dynamically adjust the AI tone (aggressive, neutral, empathetic)."
          },
          inclusionTool: {
            title: "Inclusion Tool",
            description: "Transcribe and interpret meetings in real time for people with hearing or cognitive disabilities, with simplified explanations."
          },
          insightsDashboard: {
            title: "Insights Dashboard",
            description: "View your performance over time with charts, feedback scores, and a history of simulation results."
          },
          legalSupport: {
            title: "Legal Hearing Support",
            description: "Listen to legal questions and receive answers based on jurisprudence. Capture documents and quickly interpret information."
          },
          oralExamHelp: {
            title: "Oral Exam Assistance",
            description: "Listen to committee questions and receive tips to better argue. Capture defense excerpts and get real-time suggestions."
          },
          presentationAssistant: {
            title: "Presentation Assistant",
            description: "Listen to audience questions and receive response suggestions like a confident speaker. Capture slides and generate didactic summaries."
          },
          smartCapture: {
            title: "Smart Capture with Context",
            description: "Capture images of code and select specific languages to refine AI responses, making problem-solving even more precise and powerful."
          },
          speakerCoach: {
            title: "Speaking Coach",
            description: "Simulate timed presentations and receive tips on speech, tone, and stage behavior."
          },
          techSupport: {
            title: "Technical Support (Help Desk)",
            description: "Listen to customer-reported issues and generate automatic solutions. Capture error screens and receive AI-assisted diagnostics."
          },
          translator: {
            title: "Voice Translator",
            description: "Speak in one language and receive a translated spoken response in another. Perfect for multilingual meetings and global communication."
          },
          xrayMode: {
            title: "Exclusive X-Ray Mode",
            description: "Activate X-Ray mode and make the app window floating and translucent, allowing you to write or interact with the application underneath."
          },
          stealthMode: {
            title: "100% Invisible on Screen Share",
            description: "SecretDev doesn't hide — it simply doesn't exist for screen sharing. Through an exclusive integration with the operating system, the SecretDev window is physically excluded from any video capture: Zoom, Google Meet, Teams, Discord, OBS — no software can see it. It's not an overlay, not transparency, not a trick. The window is invisible at the system level."
          },
          meetingCompanion: {
            title: "Meeting Companion",
            description: "Never miss a detail again. SecretDev follows your meetings in real time, transcribes everything automatically, lets you take notes and capture screenshots of code or documents during the call, and when it's over sends a complete email with summary, transcription, screenshots, and notes to you and all participants. Perfect for devs managing multiple projects who need to keep context across all of them effortlessly."
          },
          codeReviewer: {
            title: "Code Review Assistant",
            description: "SecretDev reads your entire project — or multiple at once, like micro frontends and microservices — and gives you immediate answers to any technical question. When the recruiter asks you to explain your architecture decisions, the AI instantly generates diagrams to illustrate your reasoning and guides you with solid arguments about patterns, trade-offs, and best practices. Those small details that eliminate candidates in technical interviews. Stay ahead of the competition. Use SecretDev."
          },
          screenshotSolver: {
            title: "Solve Any Exercise with a Screenshot",
            description: "Take a screenshot of the recruiter's exercise and get the full solution in seconds. Algorithms, hidden bugs, refactoring, complexity — the AI analyzes the snippet on screen, identifies the problem, and delivers the solved code with a step-by-step explanation. Works with any language and any type of technical challenge that comes up in your interview."
          }
        },
        "resumePdf": {
          "downloadPdf": "Download PDF",
          "contact": "Contact",
          "skills": "Skills",
          "languages": "Languages",
          "references": "References",
          "experiences": "Experience",
          "education": "Education",
          "phone": "Phone",
          "email": "Email",
          "address": "Address",
          "website": "Website",
          "github": "GitHub",
          "linkedin": "LinkedIn"
        },
        "configureResume": {
          "visualizePdf": "Visualise PDF",
          "resumeConfig": "Configure your Résumé",
          "experiences": "Experiences",
          "sendResume": "Submit Résumé",
          "aiGeneratorResume": "Generate Résumé with AI",
          "savedAlternativeResumes": "Saved Alternative Résumés",
          "personalInfo": "Personal Information",
          "name": "Name",
          "email": "Email",
          "phone": "Phone",
          "address": "Address",
          "website": "Website",
          "linkedin": "LinkedIn",
          "github": "GitHub",
          "editing": "Editing résumé:",
          "save": "Save",
          "cancel": "Cancel",
          "edit": "Edit",
          "delete": "Delete",
          "noExperience": "No experience registered.",
          "previous": "Previous",
          "next": "Next",
          "desiredRole": "Desired Role",
          "summary": "Professional Summary",
          "skills": "Skills",
          "languages": "Languages",
          "references": "References",
          "hintCommaSeparated": "Separate items with commas.",
          "hintReferencesFormat": "One per line, in the format: Name - Contact",
          "education": "Education",
          "university": "University",
          "course": "Course",
          "startDate": "Start Date",
          "endDate": "End Date",
          "placeholder": {
            "name": "e.g. Your name",
            "phone": "+55 11 99999-9999",
            "email": "youremail@domain.com",
            "address": "123 Example St - City - State",
            "website": "https://yourdomain.com",
            "linkedin": "https://linkedin.com/in/yourname",
            "github": "https://github.com/yourname",
            "desiredRole": "e.g. Full Stack Developer",
            "summary": "e.g. 5 years of experience in web development...",
            "skills": "e.g. JavaScript, React, Node.js",
            "languages": "e.g. Portuguese, English",
            "references": "e.g. John Doe - john@email.com"
          },
          "labelOriginal": "Original",
          "labelAiGenerated": "AI Generated",
          "experienceForm": {
            "title": "Professional Experience",
            "company": "Company",
            "companyPlaceholder": "e.g. Bosch",
            "role": "Role",
            "rolePlaceholder": "e.g. Software Engineer",
            "description": "Experience Description",
            "descriptionPlaceholder": "e.g. Responsible for developing the mobile app with React Native...",
            "startDate": "Start Date",
            "endDate": "End Date",
            "isCurrentJob": "Current job",
            "present": "Present",
            "add": "Add new company",
            "remove": "Remove"
          }
        },
        download: {
          title: "Download SecretDev",
          thankYou: "Thank you for supporting the project!",
          button: "Download now",
          accessDenied: "Access denied.",
          started: "Download started!",
          paymentPending: "Payment pending. Purchase a plan to download.",
          error: "Error starting download.",
          connectionError: "Connection error.",
        },
        "generateResume": {
          "title": "Generate Résumé with AI",
          "textareaPlaceholder": "Paste here the job description you are applying for",
          "back": "Back",
          "sendToAI": "Send to AI",
          "loading": "Generating...",
          "comparisonTitle": "Résumé Comparison",
          "oldResume": "Old Résumé",
          "saveAsNew": "Save as new résumé",
          "errorMissingFields": "Please provide the job description and at least one experience.",
          "errorGenerate": "Error generating résumé with AI.",
          "errorConnection": "Connection error while generating résumé with AI.",
          "errorSave": "Error saving résumé.",
          "successSave": "Résumé saved successfully!",
          "namePrompt": "Give a name for this résumé:",
          "creditConfirmMessage": "This operation will consume 1 credit. Do you want to continue?",
          "creditConfirm": "Confirm",
          "creditCancel": "Cancel",
          "operationCancelled": "Operation cancelled.",
          "outputLanguage": "Generated résumé language"
        },
        "validation": {
          "emailRequired": "Email is required",
          "emailInvalid": "Invalid email",
          "emailMissingAt": "Please include an \"@\" in the email address",
          "passwordRequired": "Password is required",
          "passwordMinLength": "Password must be at least {{count}} characters",
          "passwordConfirmRequired": "Password confirmation is required",
          "passwordsMismatch": "Passwords do not match",
          "fieldRequired": "{{field}} is required",
          "urlRequired": "URL is required",
          "urlInvalid": "Invalid URL",
          "phoneRequired": "Phone is required",
          "phoneInvalid": "Invalid phone number",
          "minLength": "{{field}} must be at least {{count}} characters",
          "maxLength": "{{field}} must be at most {{count}} characters",
          "dateFuture": "Date cannot be in the future"
        },
        tutorial: {
          title: "Tutorial",
          usesHeading: "Recommended for",
          doHeading: "Do",
          dontHeading: "Avoid",
          tabs: {
            interface: "Interface",
            modos: "Modes",
            atalhos: "Shortcuts",
            recomendacoes: "Best practices",
          },
          modes: {
            entrevista: {
              label: "Interview",
              intro: "Captures the question via <strong class='text-gray-200'>voice</strong> or <strong class='text-gray-200'>screenshot</strong> and returns a ready, structured answer — in the right format for each situation (STAR for behavioral, REACTO for live coding, ADR for architecture). Invisible during screen sharing.",
              steps: {
                s1: {
                  title: "Set up the job (optional)",
                  body: "In the header, use the <strong class='text-gray-200'>\"Job: …\"</strong> dropdown to create or activate a job. Tip: use <strong class='text-gray-200'>Import from text (✨)</strong> — paste the LinkedIn posting and the AI extracts company, role and seniority. Answers adapt to the company's style and the interview stage.",
                },
                s2: {
                  title: "Capture the question",
                  body: "If you want, lock the <strong class='text-gray-200'>language</strong> in the menu (☰) — by default it auto-detects (\"Auto-detect ▾\"). Record audio with <kbd class='kbd'>Ctrl/Cmd+Shift+Z</kbd> (start) and <kbd class='kbd'>Ctrl/Cmd+Shift+X</kbd> (stop), or capture a screenshot with <kbd class='kbd'>Ctrl/Cmd+Shift+S</kbd> — you can also paste an image from the clipboard with <kbd class='kbd'>Ctrl/Cmd+Shift+V</kbd>.",
                },
                s3: {
                  title: "Get the answer",
                  body: "The AI streams the approach, the Big O and ready-to-use code. Need to resend the attachments? Use <kbd class='kbd'>Ctrl/Cmd+Shift+R</kbd>.",
                },
                s4: {
                  title: "Use it discreetly",
                  body: "Turn on <strong class='text-gray-200'>Cheat mode</strong> (<kbd class='kbd'>Ctrl/Cmd+Shift+G</kbd>) to see only the answer, or <strong class='text-gray-200'>mini-mode</strong> (<kbd class='kbd'>Ctrl/Cmd+Shift+F</kbd>) for a compact window. To \"type\" the code straight into the editor, use <strong class='text-gray-200'>auto-typing</strong> (<kbd class='kbd'>Ctrl/Cmd+Shift+T</kbd>), which strips the comments — cancel with <kbd class='kbd'>Esc</kbd>.",
                },
              },
              uses: [
                "Online coding tests (LeetCode, HackerRank, CoderPad, Codility)",
                "Live technical interviews: theory, system design, live coding",
                "Behavioral interviews (STAR / STAR-L answers)",
                "Amazon, Google, Meta processes — adjusts the style automatically",
              ],
            },
            reuniao: {
              label: "Meeting",
              intro: "The app <strong class='text-gray-200'>transcribes the entire meeting</strong> and, at the end, generates an AI summary and <strong class='text-gray-200'>emails it</strong> to the participants you add — with summary, notes and comments.",
              steps: {
                s1: {
                  title: "Add the participants",
                  body: "Open the <strong class='text-gray-200'>Participants</strong> section and add the <strong class='text-gray-200'>name + email</strong> of everyone who should receive the summary — including yourself, if you want a copy too.",
                },
                s2: {
                  title: "Record the meeting",
                  body: "Click <strong class='text-gray-200'>Start</strong>. The app captures your microphone <strong class='text-gray-200'>and the system audio</strong> and shows the transcript in real time. During the call you can pause/resume and add notes and comments at key moments.",
                },
                s3: {
                  title: "Review the transcript",
                  body: "Click <strong class='text-gray-200'>Finish</strong>. The transcript is <strong class='text-gray-200'>editable</strong> — fix names and terms before sending. It's saved locally as a draft, so you don't lose anything if something fails.",
                },
                s4: {
                  title: "Send the summary",
                  body: "Click <strong class='text-gray-200'>Send</strong>. The AI generates the summary and fires off an email with the summary, transcript, notes and comments to all participants.",
                },
              },
              mailNote: "<strong class='text-gray-200'>Delivery is by email.</strong> There's no \"download\" button inside the app — to get your copy, just <strong class='text-gray-200'>add yourself as a participant</strong>.",
              uses: [
                "Alignment meetings and daily/planning that need minutes",
                "Client calls where you want to record what was agreed",
                "Classes and webinars to review later",
                "When you want to pay attention without writing everything by hand",
              ],
            },
            codigo: {
              label: "Code Analysis",
              intro: "Point it at a <strong class='text-gray-200'>repository on your computer</strong> and ask by voice. The AI reads the real code (Claude Code), explains it, and can propose and apply fixes with <strong class='text-gray-200'>git checkpoints</strong> to undo.",
              steps: {
                s1: {
                  title: "Select the repository",
                  body: "Open <strong class='text-gray-200'>Code Analysis</strong> mode and choose the project folder on your computer.",
                },
                s2: {
                  title: "Ask by voice",
                  body: "Record your question with <kbd class='kbd'>Ctrl/Cmd+Shift+Z</kbd> / <kbd class='kbd'>Ctrl/Cmd+Shift+X</kbd>. The AI answers based on the repository's real code.",
                },
                s3: {
                  title: "Or describe a bug in writing",
                  body: "In the <strong class='text-gray-200'>Code Assistant</strong> panel, type the problem (e.g. \"the rate limiter doesn't block the 5th request\") and click <strong class='text-gray-200'>Propose fix</strong> — no need to record audio.",
                },
                s4: {
                  title: "Apply fixes safely",
                  body: "When the AI proposes a change, each apply creates a <strong class='text-gray-200'>git checkpoint</strong> — if you don't like it, just undo.",
                },
              },
              uses: [
                "Understanding an unfamiliar project or codebase",
                "Pair programming: propose and apply changes safely",
                "Debugging and refactoring with whole-repo context",
                "Preparing for a take-home cloned on your machine",
              ],
            },
            pratica: {
              label: "Practice",
              intro: "The AI asks the questions, you answer by voice and get <strong class='text-gray-200'>feedback</strong> — choose between technical, behavioral, motivational or brain teaser.",
              steps: {
                s1: {
                  title: "Choose the question type",
                  body: "Open <strong class='text-gray-200'>Practice Mode</strong> and pick between technical, behavioral, motivational or brain teaser. The questions use your resume as a basis.",
                },
                s2: {
                  title: "Answer by voice",
                  body: "The AI asks the question; you answer out loud. At the end of each answer, you get a critique with strengths and what to improve.",
                },
              },
              uses: [
                "Rehearsing before a real interview",
                "Practicing behavioral answers and getting a critique",
                "Practicing technical questions based on your resume",
                "Gaining fluency speaking in another language",
              ],
            },
          },
          interface: {
            intro: "In Interview mode, everything lives in the <strong class='text-gray-200'>top toolbar</strong>. What each button does, from left to right:",
            caption: "Interview mode: toolbar at the top, Transcript and Oracle Response right below.",
            alt: "SecretDev Interview mode interface with the top toolbar",
            toolbarHeading: "Toolbar",
            toolbar: {
              back: "Back to the modes menu",
              xray: "X-ray (click through the window)",
              menu: "Menu (job, style, options)",
              info: "Info / help",
              color: "Change the answer color",
              font: "Increase / decrease the font",
              clear: "Clear the history",
              history: "Show / hide the history",
              replay: "Replay saved sessions",
              mock: "Mock interview",
              credits: "Remaining credit balance",
            },
            menuHeading: "Inside the menu (☰)",
            menu: {
              monitor: "Choose which screen to capture",
              lang: "Code language (or lock one)",
            },
          },
          shortcuts: {
            recHeading: "Recording & answers",
            recording: {
              start: "Start recording",
              stop: "Stop recording",
              screenshot: "Capture screenshot",
              paste: "Paste image + solve",
              solve: "Solve attachments",
              autotype: "Auto-type answer",
            },
            winHeading: "Window & discretion",
            window: {
              cola: "Cheat mode (answer only)",
              mini: "Compact mini-mode",
              xray: "X-ray (click through)",
              notes: "Notes panel",
              snippet: "Snippet Bank",
              all: "See all shortcuts",
            },
            footer: "Inside the app, press <kbd class='kbd'>Ctrl/Cmd+?</kbd> at any time to see the full list.",
          },
          recommendations: {
            intro: "The window is invisible during screen sharing, but <strong class='text-gray-200'>invisible is not undetectable</strong>. Follow these best practices so you don't expose yourself through other channels.",
            tip: "<strong class='text-white'>Capture the prompt with a screenshot — don't copy the text from the page.</strong> The screenshot (<kbd class='kbd'>Ctrl/Cmd+Shift+S</kbd>) doesn't fire an event on the site. Copying with <strong class='text-gray-200'>Ctrl+C on the test page</strong>, on the other hand, fires a <code class='text-brand-400'>copy</code> event the platform can observe.",
            do: [
              "Capture the prompt with a <strong class='text-gray-200'>screenshot</strong>.",
              "<strong class='text-gray-200'>Test invisibility beforehand</strong>: record your screen and confirm the window disappears.",
              "If asked to share your screen, share <strong class='text-gray-200'>only the test tab</strong>.",
              "Use the <strong class='text-gray-200'>global shortcuts</strong> — they don't steal focus from the tab.",
              "<strong class='text-gray-200'>Type it yourself</strong> while looking at the answer.",
            ],
            dont: [
              "<strong class='text-gray-200'>Copying the text</strong> of the prompt on the page (<code class='text-red-400'>copy</code> event).",
              "<strong class='text-gray-200'>Auto-typing</strong> in a proctored test — bulk typing draws attention.",
              "<strong class='text-gray-200'>Leaving the tab</strong> of the test — tab switching is heavily monitored.",
              "Trusting invisibility <strong class='text-gray-200'>without having tested it</strong>.",
              "Looking at a <strong class='text-gray-200'>second monitor / phone</strong> (it shows on the webcam).",
            ],
            cards: {
              share: {
                title: "Screen sharing — protected",
                body: "This is where the app has your back: the window stays invisible in the capture, even in full screen. <strong class='text-gray-200'>Run a test first</strong> to confirm on your OS.",
              },
              webcam: {
                title: "Webcam — be careful",
                body: "The camera sees <strong class='text-gray-200'>you</strong>, not the screen. Just mind your behavior and where you look.",
              },
              proctor: {
                title: "Proctoring installed — watch out",
                body: "If the process requires <strong class='text-gray-200'>installing monitoring software</strong>, screen invisibility doesn't cover everything — there, detection shifts to processes on your computer.",
              },
            },
          },
        }
      }
    }
  }
});
